

 const NDABuilder=()=> {
  return (
    <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            <div className="row mx-lg-3 mx-0">
              <div className="col-sm-6">
                <h1 className="m-0">NDA BUILDER</h1>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row  mx-lg-3 mx-0">
            <div class="col-sm-6">
                Coming Soon...

            </div>
            </div>
          </div>
        </section>
      </div>
  )
}
export default  NDABuilder